module.exports = __webpack_public_path__ + "img/java.15fa83da.svg";